import _ from 'lodash';
import { Component, DestroyRef, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule, CurrencyPipe, I18nPluralPipe } from '@angular/common';
import { PeerToPeerManageService } from 'app/manage-p2p/services/peer-to-peer-manage/peer-to-peer-manage.service';
import { ModalP2pMoveTransactionsService } from 'app/manage-p2p/services/modal-p2p-move-transactions/modal-p2p-move-transactions.service';
import { select, Store } from '@ngrx/store';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { CoreModule } from 'app/core/core.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { MdbCheckboxModule } from 'mdb-angular-ui-kit/checkbox';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { selectFundraiserReport } from 'app/manage-p2p/features/p2p.selectors';
import { peerToPeerReport } from 'app/manage-p2p/features/p2p.actions';
import { Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-p2p-move-transactions-modal',
  standalone: true,
  imports: [CommonModule,CoreModule,NgxPaginationModule,MdbCheckboxModule,FormsModule,ReactiveFormsModule, MdbSelectModule],
  templateUrl: './p2p-move-transactions-modal.component.html',
  providers: [I18nPluralPipe,CurrencyPipe],
  styleUrl: './p2p-move-transactions-modal.component.scss'
})
export class P2pMoveTransactionsModalComponent implements OnInit, OnDestroy {
  destroyRef = inject(DestroyRef)
  @Input( ) data

  public p: number = 1;
  public step = 0;
  public transactions = [];
  public isAllSelected = false;
  public selectedTransactions = null;
  public selectedCount = 0;
  public filteredTransactions = [];

  public test = ['test1','test2','test3']
  public search: UntypedFormControl = new UntypedFormControl('', []);
  public fundraiserControl: UntypedFormControl = new UntypedFormControl(null, []);
  public fundraisers = [];
  public peerToPeerId = null;
  public moveToP2P = null;
  public isUpdatePage = false;

  public fundraiserReport$: any = this.store.pipe(
    select(selectFundraiserReport)
  );

  constructor(
    public peerToPeerManageService: PeerToPeerManageService,
    public modalP2pMoveTansactionsService: ModalP2pMoveTransactionsService,
    private store: Store,
    public router: Router,
    ) { }

    ngOnInit(): void {
      
      this.transactions = this.data.transactions;
      this.filteredTransactions = this.data.transactions;

      this.peerToPeerId = this.transactions[0].peerToPeerId;
      this.unSelectAll();

      this.search.valueChanges.pipe(
       takeUntilDestroyed(this.destroyRef)
      ).subscribe(search => {
        this.filteredTransactions = _.filter(this.transactions, (transaction: any) => {
          return _.includes(transaction.payer.name.toLowerCase(), search.toLowerCase())
        });

        this.p = 1;
      });

      this.fundraiserReport$.pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe((donorReport)=> {
        this.fundraisers = donorReport.filter((fund)=>(fund.id !== this.peerToPeerId));
        if(this.isUpdatePage){
          this.router.navigateByUrl(`/manage/p2p/${this.data.campaignId}`)
        }
      })
    }

    close() {
      this.modalP2pMoveTansactionsService.close();
    }

    resetSearch() {
      this.search.setValue('');
    }

    selectAll(): void {
     this.transactions = this.data.transactions.map(transaction => {
      transaction.checked = true;
        return transaction;
      });
  
      this.isAllSelected = true;
      this.selectedCount = this.transactions.length;
      this.selectedTransactions = this.transactions;
    }

    unSelectAll(): void {
      this.transactions = this.transactions.map(option => {
        option.checked = false;
        return option;
      });
  
      this.isAllSelected = false;
      this.selectedCount = 0;
      this.selectedTransactions = [];
    }

    onChange(event, id): void {
      if (this.transactions?.length) {
        const transaction = this.transactions.find(tran => tran.id === id)
        transaction.checked = !transaction.checked;
        this.selectedTransactions = this.transactions.filter(tran => tran.checked === true);
        this.selectedCount = this.selectedTransactions?.length || 0;
      }
    }

    move(){
      let transactionIds = this.selectedTransactions.map((transaction)=>(transaction.id));
      let moveFromP2PId = this.data.id;
      let moveToP2PId = this.fundraiserControl.value;
      let campaignId = this.data.campaignId;
      this.moveToP2P = this.fundraisers.find(fund=>(fund.id==moveToP2PId))

      let params = {
        transactionIds,
        moveFromP2PId,
        moveToP2PId,
        campaignId
      }

      this.modalP2pMoveTansactionsService.moveTransactions(params).subscribe((re)=>{

        this.store.dispatch({
          type: peerToPeerReport.type,
          payload: campaignId
        });
        this.isUpdatePage = true;
        this.step = 2;
      })
    }

    getNumberStr(number){
      return this.modalP2pMoveTansactionsService.addCommasToNumber(number)
     }

     getCreated(data){
      return Math.round(new Date().getTime()  / 1000) - data;
     }

    ngOnDestroy(): void {
      this.selectedTransactions = null;
    }


}
